import { tzStrings } from "mt-components/timeZones";
import { Dispatch, SetStateAction } from "react";

export type TimeZonePickerProps = {
  timeZone: string;
  setTimeZone: Dispatch<SetStateAction<string>>;
} & React.HTMLAttributes<HTMLSelectElement>;

export default function TimeZonePicker({
  timeZone,
  setTimeZone,
  ...selectProps
}: TimeZonePickerProps) {
  return (
    <select
      {...selectProps}
      value={timeZone}
      style={{
        width: "100%",
        padding: "0.5rem",
        borderRadius: 8,
        ...selectProps.style,
      }}
      onChange={(e) => {
        const timeZone = e.target.value;
        setTimeZone(timeZone);
      }}
    >
      {tzStrings.map(({ label, value }) => (
        <option key={value} value={value}>
          {label}
        </option>
      ))}
    </select>
  );
}
